module.exports = __webpack_public_path__ + "media/images/apple-icon-120x120-6086c05d.png";